import { render, staticRenderFns } from "./ItemDeliverable.vue?vue&type=template&id=7d2b9a4f&"
import script from "./ItemDeliverable.vue?vue&type=script&lang=js&"
export * from "./ItemDeliverable.vue?vue&type=script&lang=js&"
import style0 from "./ItemDeliverable.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports